export default __webpack_public_path__ + "static/media/pizzaModule.b9f29ab7.jpg";